import React from "react";
import classnames from "classnames";
import { Container, Row, Col, Jumbotron } from "reactstrap";

import styles from "./ServiceCTA.module.scss";

const ServiceCTA = ({ primaryText, secondaryText, cta1, cta2, background, style = {} }) => {
  return (
    <div
      className={background === "apricot" ? styles.sectionWidth : `${styles.sectionWidth} bg-white`}
      style={style}
    >
      <Container>
        <Row>
          <Col xs={12} md={5}>
            <h2 className="pr-4 text-center text-md-left">{primaryText}</h2>
          </Col>
          <Col xs={12} md={{ size: 6, offset: 1 }}>
            <Row>
              <Col xs={12} md={12}>
                <p className="text-center text-md-left p-large">{secondaryText}</p>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs={12} md={5}>
                {React.isValidElement(cta1)
                  ? React.cloneElement(cta1, {
                      className: classnames(styles.sectionButton, `text-left text-md-center`),
                    })
                  : cta1}
                {/* <a href={cta1Link}>
                  <Button
                    variant="secondary"
                    text={cta1Text}
                    className={`${styles.sectionButton} text-left text-md-center`}
                  ></Button>
                </a> */}
              </Col>
              <Col
                xs={12}
                md={7}
                className="mt-3 mt-md-1 d-flex justify-content-center justify-content-md-start"
              >
                {cta2}
                {/* {(React.isValidElement(cta2)) ? React.cloneElement(cta2, { className: classnames(styles.sectionLink) }) : cta2} */}
                {/* <a href={cta2Link} className={styles.sectionLink}>
                  {cta2Text}
                </a> */}
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ServiceCTA;
